'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
type MasksState = {
  top: boolean;
  bottom: boolean;
};
export function useScrollMasks() {
  const $ = _c(5);
  const scrollableRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      top: false,
      bottom: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [masks, setMasks] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const scrollable = scrollableRef.current;
      if (!scrollable) {
        return;
      }
      const firstElement = scrollable.firstElementChild;
      const lastElement = scrollable.lastElementChild;
      if (!firstElement || !lastElement) {
        return;
      }
      const observer = new IntersectionObserver(elements => {
        for (const element of elements) {
          if (element.target === firstElement) {
            setMasks(prev => ({
              ...prev,
              top: !element.isIntersecting
            }));
          } else {
            if (element.target === lastElement) {
              setMasks(prev_0 => ({
                ...prev_0,
                bottom: !element.isIntersecting
              }));
            }
          }
        }
      }, {
        root: scrollable,
        rootMargin: "0px",
        threshold: 0
      });
      observer.observe(firstElement);
      observer.observe(lastElement);
      return () => observer.disconnect();
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== masks) {
    t3 = {
      scrollableRef,
      masks
    };
    $[3] = masks;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}